/**
 * 表情符号工具类
 * 提供常用的emoji分类和相关工具函数
 */

// 表情符号分类
export const EMOJI_CATEGORIES = {
  // 笑脸与情感
  SMILEYS: {
    name: "笑脸与情感",
    emojis: [
      "😀",
      "😃",
      "😄",
      "😁",
      "😆",
      "😅",
      "🤣",
      "😂",
      "🙂",
      "🙃",
      "😉",
      "😊",
      "😇",
      "🥰",
      "😍",
      "🤩",
      "😘",
      "😗",
      "😚",
      "😙",
      "😋",
      "😛",
      "😜",
      "🤪",
      "😝",
      "🤑",
      "🤗",
      "🤭",
      "🤫",
      "🤔",
      "🤐",
      "🤨",
      "😐",
      "😑",
      "😶",
      "😏",
      "😒",
      "🙄",
      "😬",
      "🤥",
      "😔",
      "😪",
      "🤤",
      "😴",
      "😷",
      "🤒",
      "🤕",
      "🤢",
      "🤮",
      "🤧",
      "🥵",
      "🥶",
      "🥴",
      "😵",
      "🤯",
      "🤠",
      "🥳",
      "😎",
      "🤓",
      "🧐",
      ...[
        "👋",
        "🤚",
        "🖐️",
        "✋",
        "🖖",
        "👌",
        "🤏",
        "✌️",
        "🤞",
        "🤟",
        "🤘",
        "🤙",
        "👈",
        "👉",
        "👆",
        "🖕",
        "👇",
        "☝️",
        "👍",
        "👎",
        "✊",
        "👊",
        "🤛",
        "🤜",
        "👏",
        "🙌",
        "👐",
        "🤲",
        "🤝",
        "🙏",
      ],
    ],
  },

  // 手势
  // GESTURES: {
  //   name: "手势",
  //   emojis: [
  //     "👋",
  //     "🤚",
  //     "🖐️",
  //     "✋",
  //     "🖖",
  //     "👌",
  //     "🤏",
  //     "✌️",
  //     "🤞",
  //     "🤟",
  //     "🤘",
  //     "🤙",
  //     "👈",
  //     "👉",
  //     "👆",
  //     "🖕",
  //     "👇",
  //     "☝️",
  //     "👍",
  //     "👎",
  //     "✊",
  //     "👊",
  //     "🤛",
  //     "🤜",
  //     "👏",
  //     "🙌",
  //     "👐",
  //     "🤲",
  //     "🤝",
  //     "🙏",
  //   ],
  // },

  // 动物
  ANIMALS: {
    name: "动物",
    emojis: [
      "🐶",
      "🐱",
      "🐭",
      "🐹",
      "🐰",
      "🦊",
      "🐻",
      "🐼",
      "🐨",
      "🐯",
      "🦁",
      "🐮",
      "🐷",
      "🐸",
      "🐵",
      "🐔",
      "🐧",
      "🐦",
      "🐤",
      "🐣",
      "🐥",
      "🦆",
      "🦅",
      "🦉",
      "🦇",
      "🐺",
      "🐗",
      "🐴",
      "🦄",
      "🐝",
      "🐛",
      "🦋",
      "🐌",
      "🐞",
      "🐜",
      "🦟",
      "🦗",
      "🕷️",
      "🦂",
      "🐢",
      "🐍",
      "🦎",
      "🦖",
      "🦕",
      "🐙",
      "🦑",
      "🦐",
      "🦞",
      "🦀",
      "🐡",
      "🐠",
      "🐟",
      "🐬",
      "🐳",
      "🐋",
      "🦈",
    ],
  },

  // 食物
  FOOD: {
    name: "食物",
    emojis: [
      "🍎",
      "🍐",
      "🍊",
      "🍋",
      "🍌",
      "🍉",
      "🍇",
      "🍓",
      "🍈",
      "🍒",
      "🍑",
      "🥭",
      "🍍",
      "🥥",
      "🥝",
      "🍅",
      "🍆",
      "🥑",
      "🥦",
      "🥬",
      "🥒",
      "🌶️",
      "🌽",
      "🥕",
      "🧄",
      "🧅",
      "🥔",
      "🍠",
      "🥐",
      "🥖",
      "🍞",
      "🥨",
      "🥯",
      "🧀",
      "🥚",
      "🍳",
      "🧈",
      "🥞",
      "🧇",
      "🥓",
      "🥩",
      "🍗",
      "🍖",
      "🌭",
      "🍔",
      "🍟",
      "🍕",
      "🥪",
      "🌮",
      "🌯",
      "🥙",
      "🧆",
      "🥘",
      "🍝",
      "🍜",
      "🍲",
      "🍛",
      "🍣",
      "🍱",
      "🥟",
      "🦪",
      "🍤",
      "🍙",
      "🍚",
      "🍘",
      "🍥",
      "🥠",
      "🥮",
      "🍢",
      "🍡",
      "🍧",
      "🍨",
      "🍦",
      "🥧",
      "🧁",
      "🍰",
      "🎂",
      "🍮",
      "🍭",
      "🍬",
      "🍫",
      "🍿",
      "🍩",
      "🍪",
    ],
  },

  // 活动
  ACTIVITIES: {
    name: "活动",
    emojis: [
      "⚽",
      "🏀",
      "🏈",
      "⚾",
      "🥎",
      "🎾",
      "🏐",
      "🏉",
      "🥏",
      "🎱",
      "🪀",
      "🏓",
      "🏸",
      "🏑",
      "🏒",
      "🥍",
      "🏏",
      "🥅",
      "⛳",
      "🪁",
      "🏹",
      "🎣",
      "🤿",
      "🥊",
      "🥋",
      "🎽",
      "🛹",
      "🛷",
      "⛸️",
      "🥌",
      "🎿",
      "⛷️",
      "🏂",
      "🪂",
      "🏋️‍♀️",
      "🏋️‍♂️",
      "🤼‍♀️",
      "🤼‍♂️",
      "🤸‍♀️",
      "🤸‍♂️",
      "⛹️‍♀️",
      "⛹️‍♂️",
      "🤺",
      "🤾‍♀️",
      "🤾‍♂️",
      "🏌️‍♀️",
      "🏌️‍♂️",
      "🏇",
      "🧘‍♀️",
      "🧘‍♂️",
      "🏄‍♀️",
      "🏄‍♂️",
      "🏊‍♀️",
      "🏊‍♂️",
      "🤽‍♀️",
      "🤽‍♂️",
      "🚣‍♀️",
      "🚣‍♂️",
      "🧗‍♀️",
      "🧗‍♂️",
    ],
  },

  // 符号
  SYMBOLS: {
    name: "符号",
    emojis: [
      "❤️",
      "🧡",
      "💛",
      "💚",
      "💙",
      "💜",
      "🖤",
      "🤍",
      "🤎",
      "💔",
      "❣️",
      "💕",
      "💞",
      "💓",
      "💗",
      "💖",
      "💘",
      "💝",
      "💟",
      "☮️",
      "✝️",
      "☪️",
      "🕉️",
      "☸️",
      "✡️",
      "🔯",
      "🕎",
      "☯️",
      "☦️",
      "🛐",
      "⛎",
      "♈",
      "♉",
      "♊",
      "♋",
      "♌",
      "♍",
      "♎",
      "♏",
      "♐",
      "♑",
      "♒",
      "♓",
      "🆔",
      "⚛️",
      "🉑",
      "☢️",
      "☣️",
      "📴",
      "📳",
      "🈶",
      "🈚",
      "🈸",
      "🈺",
      "🈷️",
      "✴️",
      "🆚",
      "💮",
      "🉐",
      "㊙️",
      "㊗️",
      "🈴",
      "🈵",
      "🈹",
      "🈲",
      "🅰️",
      "🅱️",
      "🆎",
      "🆑",
      "🅾️",
      "🆘",
      "❌",
      "⭕",
      "🛑",
      "⛔",
      "📛",
      "🚫",
      "💯",
      "💢",
      "♨️",
    ],
  },
};

// 获取所有表情符号
export function getAllEmojis(): string[] {
  return Object.values(EMOJI_CATEGORIES).flatMap((category) => category.emojis);
}

// 获取指定分类的表情符号
export function getEmojisByCategory(
  categoryKey: keyof typeof EMOJI_CATEGORIES,
): string[] {
  return EMOJI_CATEGORIES[categoryKey]?.emojis || [];
}

// 随机获取表情符号
export function getRandomEmoji(): string {
  const allEmojis = getAllEmojis();
  return allEmojis[Math.floor(Math.random() * allEmojis.length)];
}

// 随机获取指定数量的表情符号
export function getRandomEmojis(count: number): string[] {
  const allEmojis = getAllEmojis();
  const shuffled = [...allEmojis].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, Math.min(count, allEmojis.length));
}

// 检查字符串是否包含表情符号
export function hasEmoji(text: string): boolean {
  const emojiRegex =
    /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/u;
  return emojiRegex.test(text);
}

// 从文本中提取所有表情符号
export function extractEmojis(text: string): string[] {
  const emojiRegex =
    /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/gu;
  return text.match(emojiRegex) || [];
}

// 常用表情符号快速访问
export const COMMON_EMOJIS = {
  HAPPY: "😊",
  SAD: "😢",
  LOVE: "❤️",
  THUMBS_UP: "👍",
  THUMBS_DOWN: "👎",
  CLAP: "👏",
  FIRE: "🔥",
  STAR: "⭐",
  HEART_EYES: "😍",
  LAUGHING: "😂",
  THINKING: "🤔",
  SURPRISED: "😮",
  WINK: "😉",
  PARTY: "🎉",
  ROCKET: "🚀",
};
